import { useState } from "react";
import { navLinks, siteBrand } from "@/mocks/home";

export default function SiteNav() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="border-b border-background-200/80 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-shell items-center justify-between gap-6 px-4 md:px-6">
        <a href="#top" className="flex items-center gap-3 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-base font-bold text-background-50 dark:text-foreground-950">
            31
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              {siteBrand}
            </span>
            <span className="mt-1 text-[11px] font-label tracking-[0.2em] text-foreground-500">
              BLACK-TALK TOPICS
            </span>
          </span>
        </a>

        <div className="hidden items-center gap-8 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap text-sm font-label text-foreground-700 transition-colors duration-300 hover:text-primary-700 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#topics"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-label font-medium text-background-50 transition-colors duration-300 hover:bg-primary-600 dark:text-foreground-950 cursor-pointer"
          >
            <i className="ri-flashlight-line text-base" />
            进入黑料专题
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((value) => !value)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden cursor-pointer"
        >
          <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-3-line"}`} />
        </button>
      </div>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-6 pt-4 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between rounded-md px-3 py-3 text-sm font-label text-foreground-700 transition-colors hover:bg-background-100 cursor-pointer"
              >
                {link.label}
                <i className="ri-arrow-right-s-line text-lg text-foreground-400" />
              </a>
            ))}
          </div>
          <a
            href="#topics"
            onClick={() => setOpen(false)}
            className="mt-4 flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-label font-medium text-background-50 dark:text-foreground-950 cursor-pointer"
          >
            <i className="ri-flashlight-line text-base" />
            进入黑料专题
          </a>
        </div>
      ) : null}
    </nav>
  );
}